import localStorage from 'store'; //以后将不再使用cookie
const util = (Vue, options) => {
  Vue.prototype.$storage = localStorage; //本地存储 文档地址 https://github.com/marcuswestin/store.js
  Vue.prototype.$pureData = (data) => { //获取纯净的数组和对象
    return JSON.parse(JSON.stringify(data));
  };
  Vue.prototype.$roundNum = (begin, end) => { //获取随机整数
    var num = Math.round(Math.random() * (end - begin) + begin);
    return num;
  };
  Vue.prototype.$shuffle = (arr) => { //数组洗牌
    let i = arr.length;
    while (i) {
      let j = Math.floor(Math.random() * i--);
      [arr[j], arr[i]] = [arr[i], arr[j]];
    }
  };
  Vue.prototype.$filterNull = (val) => { //将null转化为空字符串
    if (val) {
      return val;
    } else {
      return "";
    }
  };
  Vue.prototype.$pageUtils = {
    getPageCount: function (totalNums, pageSize) {
      return totalNums == 0 ? 1 : (totalNums + pageSize - 1) / pageSize;
    }
  }

  Vue.prototype.$scrollTo = (ele, start, end, time) => {
    const a = 60;
    function scrollAnimation(scrollLeft) {
      ele.scrollLeft = scrollLeft;
    }
    let num = 0;
    const interval = setInterval(() => {
      num++;
      if (num === a) {
        clearInterval(interval);
        ele.scrollLeft = end;
      }
      start = start + (end - start) / 4;
      scrollAnimation(start);
    }, time * 1000 / a);
  }
  Vue.mixin({
    methods: {
      $language() {
        let lan = location.hash && location.hash.split('#!')[1];
        if (!lan && window.localStorage.getItem('language')) {
          lan = window.localStorage.getItem('language').split('#!')[1];
        } else if (!lan) {
          lan = 'zh';
        }
        return lan;
      }
    }
  })
}

export default util



// WEBPACK FOOTER //
// ./src/assets/util.js